import { RequestTemplate } from "store/knowledge-base-item/knowledge-base-item.types";
import { EntitiesCreatableFromResultElement, ResultSetElementType, } from "store/rs-workspace/rs-workspace.types";
export const getCreateEntityRequestTemplate = (resultElementType, entityType) => {
    const isCellModel = entityType === EntitiesCreatableFromResultElement.CellModel;
    const isVariant = entityType === EntitiesCreatableFromResultElement.Variant;
    switch (resultElementType) {
        case ResultSetElementType.Table:
            if (isVariant) {
                return RequestTemplate.VARIANT_CREATE_FROM_TABLE_RESULT_ELEMENT;
            }
            return isCellModel
                ? RequestTemplate.CELL_MODEL_CREATE_FROM_TABLE_RESULT_ELEMENT
                : RequestTemplate.RECIPE_CREATE_FROM_TABLE_RESULT_ELEMENT;
        case ResultSetElementType.ProcessDataViewer:
            if (isVariant) {
                return RequestTemplate.VARIANT_CREATE_FROM_PROCESS_DATA_RESULT_ELEMENT;
            }
            return isCellModel
                ? RequestTemplate.CELL_MODEL_CREATE_FROM_PROCESS_DATA_RESULT_ELEMENT
                : RequestTemplate.RECIPE_CREATE_FROM_PROCESS_DATA_RESULT_ELEMENT;
        case ResultSetElementType.SpaceViewer:
            if (isVariant) {
                return RequestTemplate.VARIANT_CREATE_FROM_SPACEVIEWER_RESULT_ELEMENT;
            }
            return isCellModel
                ? RequestTemplate.CELL_MODEL_CREATE_FROM_SPACEVIEWER_RESULT_ELEMENT
                : RequestTemplate.RECIPE_CREATE_FROM_SPACEVIEWER_RESULT_ELEMENT;
        case ResultSetElementType.LineGraph:
            if (isVariant) {
                return RequestTemplate.VARIANT_CREATE_FROM_LINE_GRAPH_RESULT_ELEMENT;
            }
            return isCellModel
                ? RequestTemplate.CELL_MODEL_CREATE_FROM_LINE_GRAPH_RESULT_ELEMENT
                : RequestTemplate.RECIPE_CREATE_FROM_LINE_GRAPH_RESULT_ELEMENT;
        default:
            return undefined;
    }
};
